export const MSFT_ALLOWED_DOMAINS = ['gmail.com', 'outlook.com', 'hotmail.com', 'live.com', 'yahoo.com', 'aol.com', 'bellsouth.net'];
export const OUTLOOK_REGION_PATTERN = /^outlook\.(com(\.[a-z]{2})?|co\.[a-z]{2}|[a-z]{2})$/i;
export const DOMAIN_PARSE_REGEX = /^(.+@)?([^@()]+)(\(MSFT\))?$/;

export interface ParsedDomain {
  hasPrefix: boolean;
  domainName: string;
  hasMSFTSuffix: boolean;
}

export function isValidDomainWithMSFT(domain: ParsedDomain, isForbidden: boolean): boolean {
  const { hasPrefix, hasMSFTSuffix } = domain || {};

  if (hasMSFTSuffix) {
    return hasPrefix && isForbidden;
  } else {
    return !hasPrefix && !isForbidden;
  }
}

export function isRestrictedPublicDomain(domain: ParsedDomain, isForbidden: boolean): boolean {
  const { hasPrefix, hasMSFTSuffix } = domain || {};

  return !hasPrefix && !hasMSFTSuffix && isForbidden;
}

export function isForbiddenDomain(domainName: string): boolean {
  return MSFT_ALLOWED_DOMAINS.includes(domainName) || OUTLOOK_REGION_PATTERN.test(domainName);
}

export function parseDomain(input: string): ParsedDomain | null {
  const match = input.match(DOMAIN_PARSE_REGEX);

  if (!match) return null;

  const [, prefix, domainName, MSFTTag] = match;

  return { hasPrefix: !!prefix, domainName, hasMSFTSuffix: !!MSFTTag };
}
